import IJitRepository from '../domain/IJitRepository';
import jitRepository from '../infrastructure/repositories/JitRepository';

class DownloadM100UseCase {
  private readonly _jitRepository: IJitRepository;

  constructor({ jitRepository }) {
    this._jitRepository = jitRepository;
  }

  execute({ queryParams }: { queryParams: object }) {
    return this._jitRepository.downloadM100({
      queryParams
    });
  }
}

export default new DownloadM100UseCase({
  jitRepository: jitRepository
});

export { DownloadM100UseCase };
